<template>
  <b-modal :title="title"
           :hide-footer="hideFooter"
           :hide-header-close="hideHeaderClose"
           v-model="intValue"
           @ok="success"
           @cancel="cancel"
           :cancel-title="cancelTitle"
           :ok-title="okTitle"
           @close="cancel"
           :ok-only="okOnly"
           :size="size"
           @hidden="cancel"
           :no-close-on-esc="noCloseOnEsc"
           :no-close-on-backdrop="noCloseOnBackdrop">
    <template #modal-header>
      <h5>{{ title }}</h5>
      <slot name="header-actions" />
      <span v-if="!hideHeaderClose" class="close" @click="cancel"><i class="fas fa-times" /></span>
    </template>
    <slot/>
  </b-modal>
</template>

<script>
export default {
  name: "Modal",
  props: {
    title: '',
    value: false,
    autoClose: true,
    hideFooter: false,
    cancelTitle: {
      type: String,
      default: 'Nein'
    },
    okTitle: {
      type: String,
      default: 'Ja'
    },
    okOnly: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'sm'
    },
    noCloseOnEsc: {
      type: Boolean,
      default: false
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: false
    },
    successOnClose: {
      type: Boolean,
      default: true
    },
    hideHeaderClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      intValue: this.value
    }
  },
  methods: {
    success(modal) {
      if (this.okOnly) {
        this.cancel();
        return;
      }
      this.$emit('success');
      this.close(modal);
      this.$emit('input', this.intValue);
    },
    cancel() {
      if (this.okOnly && this.successOnClose)
        this.$emit('success');

      this.$emit('cancel');
      this.intValue = false;
      this.$emit('input', this.intValue);
    },
    close(modal) {
      if (this.okOnly && this.successOnClose)
        this.$emit('success');

      if (this.autoClose)
        this.intValue = false;
      else
        modal.preventDefault();
    }
  },
  watch: {
    value(v) {
      this.intValue = v;
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
  span.close {
    cursor: pointer;
  }
</style>
